<template>
  <div class="bd">
    <!-- 监控页面 -->
    <div class="main">
      <div class="left" :style="'height:'+screenHeight">
        <div class="left-content slip_out_animation">
          <div class="type-title">
            <div>摄像头统计</div>
          </div>
          <div class="left-item-info">
            <div class="all-number">
              <div>45</div>
              <div class="text">监控总量</div>
            </div>
            <div>
              <div>通道监控：45</div>
              <div style="margin: 20px 0">拆解线监控：45</div>
              <div>全景监控：45</div>
            </div>
          </div>
        </div>

        <div class="left-content slip_out_animation">
          <div class="type-title">
            <div>安保人员巡查列表</div>
          </div>
          <div class="list-box">
            <div class="table-head">
              <div>仓库</div>
              <div>人员</div>
              <div>状态</div>
              <div>时间</div>
            </div>
            <div class="table-main">
              <div class="main-item">
                <div>仓库名字</div>
                <div>张三</div>
                <div>异常</div>
                <div>12:22</div>
              </div>
              <div class="main-item">
                <div>仓库名字</div>
                <div>张三</div>
                <div>异常</div>
                <div>12:22</div>
              </div>
              <div class="main-item">
                <div>仓库名字</div>
                <div>张三</div>
                <div>异常</div>
                <div>12:22</div>
              </div>
              <div class="main-item">
                <div>仓库名字</div>
                <div>张三</div>
                <div>异常</div>
                <div>12:22</div>
              </div>
              <div class="main-item">
                <div>仓库名字</div>
                <div>张三</div>
                <div>异常</div>
                <div>12:22</div>
              </div>
              <div class="main-item">
                <div>仓库名字</div>
                <div>张三</div>
                <div>异常</div>
                <div>12:22</div>
              </div>
            </div>
          </div>
        </div>
        <div class="left-content slip_out_animation">
          <div class="type-title">
            <div>安保事件列表</div>
          </div>
          <div class="bottom-list-box">
            <div>仓库二存在安全隐患，需要进行处理</div>
            <div>仓库二存在安全隐患，需要进行处理</div>
            <div>仓库二存在安全隐患，需要进行处理</div>
            <div>仓库二存在安全隐患，需要进行处理</div>
            <div>仓库二存在安全隐患，需要进行处理</div>
            <div>仓库二存在安全隐患，需要进行处理</div>
            <div>仓库二存在安全隐患，需要进行处理</div>
            <div>仓库二存在安全隐患，需要进行处理</div>
            <div>仓库二存在安全隐患，需要进行处理</div>
            <div>仓库二存在安全隐患，需要进行处理</div>
            <div>仓库二存在安全隐患，需要进行处理</div>
            <div>仓库二存在安全隐患，需要进行处理</div>
            <div>仓库二存在安全隐患，需要进行处理</div>
            <div>仓库二存在安全隐患，需要进行处理</div>
            <div>仓库二存在安全隐患，需要进行处理</div>
            <div>仓库二存在安全隐患，需要进行处理</div>
            <div>仓库二存在安全隐患，需要进行处理</div>
            <div>仓库二存在安全隐患，需要进行处理</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "indexModelTwo",
  props: ["screenHeight"],
  data() {
    return {
      selectIndex: 1,
      nowTime: "",
    };
  },
  methods: {},
};
</script>
  <style scoped lang="scss">
::-webkit-scrollbar {
  width: 0px;
}

.main .left {
  width: 21.5vw;
  height: 75vh;
  background: rgba(17,47,107, 0.6);
  overflow: hidden;
}
.main .left {
  float: left;
  margin-left: 20px;
  .left-content {
    box-sizing: border-box;
    padding: 20px;
    color: #fff;
  }
  .left-content .company-content {
    line-height: 40px;
    font-size: 18px;
    height: 51vh;
    overflow-y: scroll;
    scroll-behavior: smooth;
    overscroll-behavior: contain;
  }
  .left-item-info {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 20px 0;
    .all-number {
      font-size: 22px;
      text-align: center;
      .text {
        margin-top: 20px;
        font-size: 28px;
      }
    }
  }
}
.list-box {
  background: #4e83ca;
  padding: 10px 0;
  .table-head,
  .main-item {
    /* padding: 5px 20px; */
    display: flex;
    align-items: center;
    font-size: 14px;
  }
  .table-head {
    padding-bottom: 10px;
    border-bottom: 1px rgb(193, 193, 193) solid;
  }
  .table-head > div,
  .main-item > div {
    width: 25%;
    text-align: center;
  }

  .main-item > div {
    border-bottom: 1px rgb(193, 193, 193) solid;
  }
  .table-main {
    line-height: 80px;
    font-size: 18px;
    height: 15vh;
    overflow-y: scroll;
    scroll-behavior: smooth;
    overscroll-behavior: contain;
  }
}
.bottom-list-box {
  /* background: #4e83ca; */
  padding-left:20px;
  line-height: 80px;
  font-size: 18px;
  height: 32vh;
  overflow-y: scroll;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
}
::v-deep .main .left .left-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
  